import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {User} from "../entities/User";
import axios from "axios";
import {getToken} from "../repositories/TokenRepository";

interface UserState {
    value: User | null;
    latestFetchRequestId: string | null;
}

const initialState: UserState = {
    value: null,
    latestFetchRequestId: null,
};

export const fetchUser = createAsyncThunk('user/fetchUser', async (id, {rejectWithValue}) => {
    try {
        const response = await axios.get(process.env.REACT_APP_API_URL + '/user/' + id, {
            headers: {
                'Api-Key': `Bearer ${getToken()}`
            }
        });
        return response.data;
    } catch (error) {
        return (rejectWithValue as any)(error);
    }
})

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        clearUser: () => {
            return initialState;
        },

    },
    extraReducers(builder) {
        builder.addCase(fetchUser.pending, (state, action) => {
            state.latestFetchRequestId = action.meta.requestId;
        })
        builder.addCase(fetchUser.fulfilled, (state, action) => {
            // ignore responses of outdated requests (previously viewed user)
            if (action.meta.requestId !== state.latestFetchRequestId) return;
            state.value = action.payload;
        })
    },
})

export const { clearUser } = userSlice.actions


export default userSlice.reducer
